import Colors from '../../../Configs/colors';

const styles = {
  root: {
    display: 'flex',
    fontSize: 16,
    '& .logo': {
      width: 80,
      objectFit: 'cover',
      height: 80,
      // borderRadius: 40,
    },
    '& .navigation': {
      '& .link': {
        padding: '12px 8px',
        borderRadius: 8,
        fontWeight: '600',
        color: '#2E3C40',
        '&.dropdownChild': {
          padding: '8px 8px 8px 40px',
          fontSize: 14,
        },
        '&.active': {
          background: '#FDE0E0',
          color: Colors.primary,
        },
        '&:hover': {
          background: '#FDE0E0',
        },
      },
      '& .dropdown': {
        padding: '12px 8px',
        textDecoration: 'none',
        borderRadius: 8,
        fontWeight: '600',
        color: '#2E3C40',
        '&.active': {
          color: Colors.primary,
        },
      },
    },
    '& main': {
      height: '100vh',
      background: '#F7F7FA',
      overflow: 'auto',
      boxSizing: 'border-box',
      position: 'relative',
      '& .top-nav': {
        background: Colors.white,
        borderBottom: '1px solid #DADADA',
        boxSizing: 'border-box',
      },
      '& .now-date': {
        padding: '8px 16px',
        background: 'transparent',
        borderRadius: 8,
        color: '#6A6A6A',
        border: '1px solid #DADADA',
      },
      '& .upload-sect': {
        border: '1px dashed #6A6A6A',
        borderRadius: 8,
        background: '#F7F7FA',
        height: 120,
        width: 120,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#6A6A6A',
        cursor: 'pointer',
        '&.large': {
          width: 180,
        },
      },
    },

    '& .MuiPagination-root': {
      '& button': {
        color: '#586479 !important',
        margin: '0 4px !important',
        '&:hover, &.Mui-selected': {
          backgroundColor: '#B4112E !important',
          color: '#fff !important',
          border: 'none !important',
        },
      },
    },

  },
};

export default styles;
